/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useContext, useEffect, useId } from 'react';
import noop from 'lodash/noop';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import Context, { type ExperienceContext } from '../../common/context/index.tsx';
import type { TrackerProps } from '../../common/types.tsx';
import TrackerBase from './view.tsx';

export const ExperienceTracker = ({
	children = null,
	location,
	failureEventAttributes = null,
	parentProviders = null,
}: TrackerProps): React.JSX.Element | null => {
	const experienceTrackerId = useId();

	const context: ExperienceContext | null = useContext(Context);
	useEffect(() => {
		if (context === null) {
			log.safeErrorWithoutCustomerData(
				'experience-tracker.missing-provider',
				'Experience tracker rendered without a provider',
			);
		}
	}, [context]);
	if (context == null || __SERVER__) {
		return typeof children === 'function' ? (
			children({
				onExperienceSuccess: noop,
				onExperienceFailure: noop,
				onExperienceAbort: noop,
			})
		) : (
			<>{children}</>
		);
	}
	return (
		<TrackerBase
			experienceTrackerId={
				fg('jfp-magma-use-location-for-experience-tracker') ? location : experienceTrackerId
			}
			location={location}
			experienceContext={context}
			failureEventAttributes={failureEventAttributes}
			parentProvidersWhitelist={parentProviders}
		>
			{children}
		</TrackerBase>
	);
};
